module.exports = __webpack_public_path__ + "bcc3bf25fda552838301326894e51bdc.svg";